export default {"src":"/_next/static/media/bnb.5948fe5e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};